import { useState, type FormEvent } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useMe } from '@/hooks/useMe';
import { authApi } from '@/lib/auth';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

export default function RegisterName() {
  const { data: me } = useMe();
  const qc = useQueryClient();
  const [fullName, setFullName] = useState(me?.firstName ?? '');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await authApi.saveProfile(fullName.trim());
      await qc.invalidateQueries({ queryKey: ['me'] });
    } catch {
      setErr('Не удалось сохранить имя');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-tg-bg">
      <Card className="w-full max-w-sm space-y-4">
        <h1 className="text-xl font-semibold text-center">Как вас зовут?</h1>
        <form onSubmit={submit} className="space-y-3">
          <input
            className="w-full rounded-lg border border-tg-secondaryBg bg-tg-bg px-3 py-2"
            placeholder="Ваше имя (ФИО)"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          {err && <div className="text-sm text-red-500">{err}</div>}
          <Button type="submit" disabled={busy || fullName.trim().length < 2} className="w-full">
            {busy ? 'Сохраняем…' : 'Продолжить'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
